/**
 * @description Check if the device is an Apple device
 * @returns {boolean} - True if the device is an Apple device
 */
export function checkIfAppleDevice(): boolean {
  const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent

  return /Mac|iPhone|iPad|iPod/.test(userAgent)
}
